<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
      <!-- eslint-disable-next-line max-len -->
      <v-tab v-for="tab of tabs" class="common-font-size" :key="tab.id" @click="WarnUser(tab.to)" :id="`mtgTransSequenceTab${tab.id}`"
        :class="`mtg-trans-sequence-tab-${tab.id}`">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CommonDropDownsMixins from '../components/tax/common-utils/CommonDropDowns.mixin.vue';
import '../assets/style.css';
import { transformMapperListFields } from '../util/shared/transform';

export default {
  name: 'TaxRollAdjustments',
  mixins: [CommonDropDownsMixins],
  components: {
  },
  created() {
    this.getPathName();
    this.loadDropDownList();
  },
  updated() {
    this.getPathName();
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/tax/adjustments/adjustmentssearch' }, caption: 'Tax Roll Adjustments' },
      { id: 2, to: { path: '/tax/adjustments/assessorupdate' }, caption: 'Assessor Update' },
      { id: 3, to: { path: '/tax/adjustments/reports' }, caption: 'Reports' },
    ],
  }),
  methods: {
    ...mapActions('config', [
      'loadTransformMappers',
    ]),
    async loadDropDownList() {
      await this.loadTransformMappers({
        criteria: { type: 'import', program: 'TAX' },
        fields: { ...transformMapperListFields },
        baseCrudKey: 'transform-mapper-list',
      });
      await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      await this.loadTaxDistrict({
        criteria: {
          sortBy: [{
            column: 'districtCode',
            direction: 'asc',
          }],
        },
        baseCrudKey: 'sharedTaxDistrict',
      });
      await this.loadtaxAdjTypesSharedRecords({
        criteria: { sortBy: [{ column: 'adjType', direction: 'asc' }] },
        postProcessTrans: this.postProccessAdjTypesData,
        baseCrudKey: 'taxAdjTypesList',
      });
    },
    getPathName() {
      const curPath = this.$route.path;
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      this.activetab = ftr[0].id !== undefined ? ftr[0].id - 1 : 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },
};
</script>
